<template>
    <div>
        <b-card
            :title="title"
            :sub-title="subtitle"
            :img-src="icon"
            :class="{hovered:isHovered}"
            @mouseover="isHovered = true"
            @mouseout="isHovered = false"
            @click="onClick"
        />
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue';
export default {
    name: 'PartnerCard',

    props: {
        title: String,
        subtitle: String,
        icon: String,
    },

    data() {
        return {
            isHovered: false,
        };
    },

    methods: {
        onClick() {
            this.$emit('click');
        }
    }
};
</script>